import DeliverableCard from './components/DeliverableCard';
import type { Database } from '@/types/database.types';
type Project = Database['public']['Tables']['projects']['Row'];
type ProjectTeam = Database['public']['Tables']['projects_team']['Row'];
type Deliverable = Database['public']['Tables']['deliverables']['Row'];
type DeliverableTeam = Database['public']['Tables']['deliverables_team']['Row'];
type Member = Database['public']['Tables']['project_members']['Row'];
type ProjectWithTeamAndMembers = Project & {
  projects_team: ProjectTeam;
} & { project_members: Member[] | null };
type DeliverableWithTeam = Deliverable & {
  deliverables_team: DeliverableTeam;
};

export default function VideosTab({
  deliverables,
  project,
}: {
  deliverables: DeliverableWithTeam[];
  project: ProjectWithTeamAndMembers;
}) {
  const allDeliverables = deliverables.map((deliverable) => (
    <DeliverableCard
      deliverable={deliverable}
      key={deliverable.id}
      project={project}
    />
  ));

  return <div>{allDeliverables}</div>;
}
